<template>
  <index-panel
    page="Player"
    collection="players"
    :title="$route.params.name"
    :doc="$route.params.name"
  />
</template>

<script>
import IndexPanel from './IndexPanel';

export default {
  components: {
    IndexPanel,
  },
};
</script>
